module.exports = __webpack_public_path__ + "img/image_19.8213632e.png";